import type { CityConfig } from "../city-template/types";

export const mooresvilleConfig: CityConfig = {
  city: "Mooresville",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "mooresville",
  route: "/cities/mooresville",
  title: "Emergency Passport Mooresville, NC | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Mooresville, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Iredell County and the Lake Norman area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Mooresville, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Mooresville and Lake Norman area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Mooresville%20North%20Carolina%20scenic%20landscape%20at%20golden%20hour%20with%20Lake%20Norman%20waterfront%2C%20upscale%20suburban%20neighborhoods%20along%20the%20shoreline%2C%20modern%20Lake%20Norman%20community%2C%20green%20rolling%20hills%20of%20Iredell%20County%2C%20charming%20small%20town%20main%20street%20with%20historic%20buildings%2C%20warm%20sunset%20light%20with%20clean%20sky%2C%20professional%20landscape%20photography%20with%20warm%20earthy%20tones%20and%20lake%20community%20atmosphere%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=mooresville-hero-nc-001&orientation=landscape",
  heroImageAlt: "Mooresville North Carolina Lake Norman area with scenic waterfront and suburban neighborhoods at golden hour",
  geoPosition: "35.5849;-80.8101",
  geoPlacename: "Mooresville, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 240 miles from Mooresville via I-85",
  },
  nearbyCitiesZips: [
    { name: "Mooresville", zips: "28115, 28117" },
    { name: "Davidson", zips: "28035, 28036" },
    { name: "Cornelius", zips: "28031" },
    { name: "Huntersville", zips: "28070, 28078" },
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Concord", zips: "28025, 28026, 28027" },
    { name: "Kannapolis", zips: "28081, 28082, 28083" },
    { name: "Statesville", zips: "28625, 28677, 28687" },
    { name: "Troutman", zips: "28166" },
    { name: "Mocksville", zips: "27028" },
    { name: "Salisbury", zips: "28144, 28145, 28146, 28147" },
    { name: "Denver", zips: "28037" },
    { name: "Lake Norman", zips: "28031, 28036, 28117" },
    { name: "Lincolnton", zips: "28092, 28093" },
    { name: "Stanley", zips: "28164" },
    { name: "Mount Holly", zips: "28120" },
    { name: "Belmont", zips: "28012" },
    { name: "Gastonia", zips: "28052, 28054, 28056" },
    { name: "Harrisburg", zips: "28075" },
    { name: "Hickory", zips: "28601, 28602, 28603" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Iredell County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Lake Norman Hub", desc: "Serving Mooresville, Davidson, Cornelius, and the Lake Norman communities" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Fast passport renewal in Concord, NC", route: "/cities/concord-nc" },
    { name: "Emergency passport help in Huntersville, NC", route: "/cities/huntersville" },
    { name: "Urgent passport services in Cornelius, NC", route: "/cities/cornelius" },
    { name: "Same-day passport help in Davidson, NC", route: "/cities/davidson" },
    { name: "Urgent passport services in Kannapolis, NC", route: "/cities/kannapolis" },
    { name: "Same-day passport help in Hickory, NC", route: "/cities/hickory" },
    { name: "Passport courier services in Gastonia, NC", route: "/cities/gastonia" },
    { name: "Expedited passport services in Statesville, NC", route: "/cities/statesville" },
    { name: "Fast passport renewal in Salisbury, NC", route: "/cities/salisbury" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Mooresville remotely via secure courier. We do not have a walk-in office in Mooresville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Iredell County and the Lake Norman area travelers.",
  fpcOfficeDistance: "Serving all of Iredell County and the Lake Norman metropolitan region",
  serviceAreaIntro: "From the waterfront neighborhoods of Lake Norman to the historic streets of downtown Mooresville, from the college town of Davidson to the growing communities of Cornelius and Huntersville, from the bustling corridors of north Charlotte to the quiet roads of Troutman and Denver — Fast Passport Center serves the entire Mooresville region. We regularly help travelers from Statesville, Mocksville, Salisbury, and the Lake Norman area get their passports fast.",
  nearbyCitiesIntro: "We serve all Mooresville neighborhoods and the surrounding Lake Norman area including Davidson, Cornelius, Huntersville, Charlotte, Concord, Kannapolis, Statesville, Troutman, Mocksville, Salisbury, Denver, Lake Norman, Lincolnton, Stanley, Mount Holly, Belmont, Gastonia, and Harrisburg. If you are anywhere in Iredell County, Mecklenburg County, or the Lake Norman metropolitan area, we have you covered.",
  howItWorksIntro: "Most Mooresville travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Mooresville travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Mooresville and Lake Norman travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Mooresville? Here are the most common ones we hear from Iredell County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Mooresville international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Brian T.",
      location: "Mooresville, NC",
      rating: 5,
      text: "My passport expired the week before my honeymoon to St. Lucia. Fast Passport Center had my renewal ready in 30 hours. I never had to leave Mooresville. Outstanding service for Lake Norman families.",
      service: "Passport Renewal",
    },
    {
      name: "Derek M.",
      location: "Davidson, NC",
      rating: 5,
      text: "Emergency passport for a business trip to London. Got it in 27 hours. Fast Passport Center handled everything — I didn't have to drive to Atlanta. Saved a major client meeting.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah K.",
      location: "Cornelius, NC",
      rating: 5,
      text: "First passport for my 12-year-old before our summer trip to Europe. Fast Passport Center walked us through every step and had her passport in 4 days. So easy for Lake Norman parents.",
      service: "Child Passport",
    },
    {
      name: "James R.",
      location: "Huntersville, NC",
      rating: 5,
      text: "Lost my passport 3 days before a cruise to the Caribbean. Fast Passport Center had a replacement in my hands in 29 hours. Their service across the Lake Norman area is unmatched.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "mooresville-1",
      name: "Mooresville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 E Plaza Dr",
      city: "Mooresville",
      state: "NC",
      zip: "28115",
      phone: "(704) 663-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Mooresville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Mooresville facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "mooresville-2",
      name: "Davidson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "202 S Main St",
      city: "Davidson",
      state: "NC",
      zip: "28036",
      phone: "(704) 892-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles south of Mooresville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Davidson and southern Iredell County. Good for college community residents.",
      icon: "ri-mail-line",
    },
    {
      id: "mooresville-3",
      name: "Cornelius Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "20210 W Catawba Ave",
      city: "Cornelius",
      state: "NC",
      zip: "28031",
      phone: "(704) 892-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles south of Mooresville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Cornelius and Lake Norman area. Less crowded than Charlotte. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "mooresville-4",
      name: "Huntersville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16405 N Cross Ave",
      city: "Huntersville",
      state: "NC",
      zip: "28078",
      phone: "(704) 875-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles south of Mooresville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Mecklenburg County. Good for Huntersville and Lake Norman residents.",
      icon: "ri-mail-line",
    },
    {
      id: "mooresville-5",
      name: "Statesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 W Front St",
      city: "Statesville",
      state: "NC",
      zip: "28677",
      phone: "(704) 873-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles north of Mooresville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Iredell County and Statesville area. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "mooresville-6",
      name: "Iredell County Register of Deeds",
      type: "County Clerk Passport Acceptance",
      address: "221 E Water St",
      city: "Statesville",
      state: "NC",
      zip: "28677",
      phone: "(704) 878-3000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "20 miles north of Mooresville",
      website: "https://www.iredellcountync.gov/",
      websiteLabel: "Iredell County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Mooresville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Iredell County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Mooresville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Iredell County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Mooresville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Mooresville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Mooresville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Mooresville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Mooresville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Mooresville?", a: "Fast Passport Center offers fast passport renewal in Mooresville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Mooresville?", a: "The nearest regional passport agency to Mooresville is the Atlanta Passport Agency, approximately 240 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Mooresville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Mooresville?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 4 hours from Mooresville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Iredell County and Lake Norman residents." },
    { q: "Do you serve the entire Lake Norman area?", a: "Absolutely. Fast Passport Center serves the entire Lake Norman metropolitan area including Mooresville, Davidson, Cornelius, Huntersville, Charlotte, Concord, Kannapolis, Statesville, Troutman, Mocksville, Salisbury, Denver, Lake Norman, Lincolnton, Stanley, Mount Holly, Belmont, Gastonia, and Harrisburg. Our courier service works seamlessly from any address in Iredell County, Mecklenburg County, and surrounding areas." },
    { q: "Can I expedite a child passport in Mooresville?", a: "Yes. Fast Passport Center expedites child passports in Mooresville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Iredell County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Mooresville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Mooresville", address: "569 River Hwy, Mooresville, NC 28117", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Mooresville", address: "481 E Plaza Dr, Mooresville, NC 28115", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Mooresville", address: "169 Norman Station Blvd, Mooresville, NC 28117", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Davidson", address: "624 Jetton St, Davidson, NC 28036", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Cornelius", address: "19701 W Catawba Ave, Cornelius, NC 28031", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Huntersville", address: "16623 Birkdale Commons Pkwy, Huntersville, NC 28078", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Statesville", address: "1121 E Broad St, Statesville, NC 28677", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Charlotte", address: "550 S Tryon St, Charlotte, NC 28202", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Mooresville",
      address: "118 Four Seasons Town Centre, Mooresville, NC 28117",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Huntersville",
      address: "1625 N Cross Ave, Huntersville, NC 28078",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Statesville",
      address: "1415 W Innes St, Statesville, NC 28677",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Iredell County and northern Lake Norman area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Charlotte North",
      address: "7520 N Tryon St, Charlotte, NC 28262",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Charlotte metro and north Mecklenburg area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "25 miles south of Mooresville",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international airport for the Charlotte metro area. American Airlines hub with direct flights to Europe, Mexico, the Caribbean, and major domestic destinations. Only 30 minutes from Mooresville.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "60 miles northeast of Mooresville",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for North Carolina residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "150 miles east of Mooresville",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
};